import React from 'react'
import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';

interface Props {
    onReload: () => void,
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        reloadButton: {
            marginTop: theme.spacing(0.5),
            marginRight: theme.spacing(3),
            padding: '0',
        },
        iconStyle: {
            padding: '0',
            color: 'grey',
            height: '30',
            width: '30'
        }
    }),
);

export default ((props) => {
    const classes = useStyles();

    return (
        <IconButton aria-label='reload' className={classes.reloadButton} onClick={() => props.onReload()}>
            <CachedIcon className={classes.iconStyle} />
        </IconButton>
    )
}) as React.FC<Props>;
